import React from 'react'
import imgPort from '../../assets/portfolio/1.png'
import imgPort2 from '../../assets/portfolio/2.png'
import imgPort3 from '../../assets/portfolio/3.png'
import imgPort4 from '../../assets/portfolio/4.png'
import imgPort5 from '../../assets/portfolio/5.png'
import imgPort6 from '../../assets/portfolio/6.png'
import imgPort7 from '../../assets/portfolio/7.png'
import imgPort8 from '../../assets/portfolio/8.png'
import imgPort9 from '../../assets/portfolio/9.png'


const Portfolio = () => {
    return (
        <section id="portfolio">

            <div className="row section-intro" data-aos="fade-up">
                <div className="col-twelve">

                    <h5>Portfolio</h5>
                    <h1>Check Out Some of My Works.</h1>
                </div>   		
            </div>

            <div className="row portfolio-content">

                <div className="col-twelve">
                    <div id="folio-wrapper" className="block-1-2 block-mob-full stack">

                        <div className="bgrid folio-item" data-aos="zoom-in-right">
                            <div className="item-wrap">
                                <img src={imgPort9} alt="UX Design Course" />
                                <a href="#modal-00" rel="noreferrer" className="overlay">
                                    <div className="folio-item-table">
                                        <div className="folio-item-cell">
                                            <h3 className="folio-title">UX Design Course</h3>	     					    
                                                    <span className="folio-types">
                                                        Redesign in Laravel (Blade templates) + Bootstrap
                                                    </span>		     		
                                            </div>	                      	
                                    </div>                    
                                </a>
                            </div>
                        </div>

                        <div className="bgrid folio-item" data-aos="zoom-in-right">
                            <div className="item-wrap">
                                <img src={imgPort6} alt="Ofertopoli" />
                                <a href="#modal-01" rel="noreferrer" className="overlay">
                                    <div className="folio-item-table">
                                        <div className="folio-item-cell">
                                            <h3 className="folio-title">Ofertopoli</h3>	     					    
                                                    <span className="folio-types">
                                                        ReactJS+Redux, TailwindCSS
                                                    </span>		     		
                                            </div>	                      	
                                    </div>                    
                                </a>
                            </div>
                        </div>

                        <div className="bgrid folio-item" data-aos="zoom-in-left">
                            <div className="item-wrap">
                                <img src={imgPort8} alt="Donal's Kitchen" />
                                <a href="#modal-02" rel="noreferrer" className="overlay">              		                  
                                    <div className="folio-item-table">
                                        <div className="folio-item-cell">
                                            <h3 className="folio-title">Donal's Kitchen</h3>	     					    
                                                    <span className="folio-types">
                                                    Created in WordPress + TailwindCSS
                                                </span>		     		
                                            </div> 	                      	
                                    </div>                    
                                </a>
                            </div>
                        </div>

                        <div className="bgrid folio-item" data-aos="zoom-in-right">
                            <div className="item-wrap">
                                <img src={imgPort2} alt="Logiskills Group" />
                                <a href="#modal-03" rel="noreferrer" className="overlay">              		                  
                                    <div className="folio-item-table">
                                        <div className="folio-item-cell">
                                            <h3 className="folio-title">Logiskills Group</h3>	     					    
                                                    <span className="folio-types">
                                                    Created in WordPress + Bootstrap
                                                </span>		     		
                                            </div> 	                      	
                                    </div>                    
                                </a>
                            </div>
                        </div>

                        <div className="bgrid folio-item" data-aos="zoom-in-left">
                            <div className="item-wrap">
                                <img src={imgPort} alt="The Business Post" />
                                <a href="#modal-04" rel="noreferrer" className="overlay">	                  	           
                                    <div className="folio-item-table">
                                        <div className="folio-item-cell">
                                                <h3 className="folio-title">The Business Post</h3>	     					    
                                                    <span className="folio-types">
                                                    AMP Components, TailwindCSS, AlpineJS
                                                </span>
                                            </div>	                      	
                                    </div>                    
                                </a>
                            </div>	               
                        </div>

                        <div className="bgrid folio-item" data-aos="zoom-in-right">
                            <div className="item-wrap">
                                <img src={imgPort7} alt="Assure Hedge" />
                                <a href="#modal-05" rel="noreferrer" className="overlay">	                  	           
                                    <div className="folio-item-table">
                                        <div className="folio-item-cell">
                                                <h3 className="folio-title">Assure Hedge</h3>	     					    
                                                    <span className="folio-types">
                                                    Created in WordPress
                                                </span>
                                            </div>	                      	
                                    </div>                    
                                </a>
                            </div>	               
                        </div>

                        <div className="bgrid folio-item" data-aos="zoom-in-left">
                            <div className="item-wrap">
                                <img src={imgPort3} alt="Gale International" />
                                <a href="#modal-06" rel="noreferrer" className="overlay">             		                  
                                    <div className="folio-item-table">
                                        <div className="folio-item-cell">
                                            <h3 className="folio-title">Gale International</h3>	     					    
                                                    <span className="folio-types">
                                                    Created in WordPress + Bootstrap
                                                </span>		     		
                                            </div> 	                      	
                                    </div>                    
                                </a>
                            </div>
                        </div> 

                        <div className="bgrid folio-item" data-aos="zoom-in-right">
                            <div className="item-wrap">
                                <img src={imgPort4} alt="Antique Homes" />
                                <a href="#modal-07" rel="noreferrer" className="overlay">                  	                 
                                    <div className="folio-item-table">
                                        <div className="folio-item-cell">
                                            <h3 className="folio-title">Antique Homes</h3>	     					    
                                                    <span className="folio-types">
                                                    Created in WordPress + Bootstrap
                                                </span>		     		
                                            </div>  	                      	
                                    </div>                    
                                </a>
                            </div>
                        </div>  

                        <div className="bgrid folio-item" data-aos="zoom-in-left">
                            <div className="item-wrap">
                                <img src={imgPort5} alt="Focalyx iOS" />
                                <a href="#modal-08" rel="noreferrer" className="overlay">             		                  
                                    <div className="folio-item-table">
                                        <div className="folio-item-cell">
                                            <h3 className="folio-title">Focalyx iOS</h3>	     					    
                                                    <span className="folio-types">
                                                    XCode using Auto Layout Techniques in Interface builder
                                                </span>		     		
                                            </div> 	                      	
                                    </div>                    
                                </a>
                            </div>
                        </div>


                        <div id="modal-00" className="popup-modal slider mfp-hide">	

                            <div className="media">
                                <img src={imgPort9} alt="Ofertopoli" />
                            </div>      	

                            <div className="description-box">
                                <h4>UX Design Course</h4>		      
                                <p>Redesign in Laravel (Blade templates) + Bootstrap</p>

                                <div className="categories">Web Development</div>			               
                            </div>

                            <div className="link-box">
                                <a target="_blank" rel="noreferrer" href="https://www.uxdesigninstitute.com/">View site</a>
                                <a href="/#" rel="noreferrer" className="popup-modal-dismiss">Close</a>
                            </div>		      

                        </div>
                        
                        <div id="modal-01" className="popup-modal slider mfp-hide">	

                            <div className="media">
                                <img src={imgPort6} alt="Ofertopoli" />
                            </div>      	

                            <div className="description-box">
                                <h4>Ofertopoli</h4>		      
                                <p>ReactJS, TailwindCSS</p>

                                <div className="categories">Web Development</div>			               
                            </div>

                            <div className="link-box">
                                <a target="_blank" rel="noreferrer" href="https://ofertopoli.com/">View site</a>
                                <a href="/#" rel="noreferrer" className="popup-modal-dismiss">Close</a>
                            </div>		      

                        </div>

                        <div id="modal-02" className="popup-modal slider mfp-hide">	

                            <div className="media">
                                <img src={imgPort8} alt="Donal's Kitchen" />
                            </div>      	

                            <div className="description-box">
                                <h4>Donal's Kitchen</h4>		      
                                <p>Created in WordPress + TailwindCSS</p>
                                <p>Company: Square1</p>

                                <div className="categories">Web Development</div>			               
                            </div>

                            <div className="link-box">
                                <a target="_blank" rel="noreferrer" href="https://donalskitchen.com/">View site</a>
                                <a href="/#" rel="noreferrer" className="popup-modal-dismiss">Close</a>
                            </div>		      

                        </div>

                        <div id="modal-03" className="popup-modal slider mfp-hide">	

                            <div className="media">
                                <img src={imgPort2} alt="Logiskills Group" />
                            </div>      	

                            <div className="description-box">
                                <h4>Logiskills Group</h4>		      
                                <p>Created in WordPress + Bootstrap</p>
                                <p>Company: Square1</p>

                                <div className="categories">Web Development</div>			               
                            </div>

                            <div className="link-box">
                                <a target="_blank" rel="noreferrer" href="https://www.logiskills.ie/">View site</a>
                                <a href="/#" rel="noreferrer" className="popup-modal-dismiss">Close</a>
                            </div>		      

                        </div>

                        <div id="modal-04" className="popup-modal slider mfp-hide">	

                                <div className="media">
                                    <img src={imgPort} alt="The Business Post" />
                                </div>      	

                            <div className="description-box">
                                <h4>The Business Post</h4>		      
                                <p>AMP Components, TailwindCSS, AlpineJS</p>
                                <p>Company: Square1</p>

                                <div className="categories">Web Development</div>			               
                            </div>

                            <div className="link-box">
                                <a target="_blank" rel="noreferrer" href="https://www.businesspost.ie/">View site</a>
                                <a href="/#" rel="noreferrer" className="popup-modal-dismiss">Close</a>
                            </div>		      

                        </div>

                        <div id="modal-05" className="popup-modal slider mfp-hide">	

                                <div className="media">
                                    <img src={imgPort7} alt="Assure Hedge" />
                                </div>      	

                            <div className="description-box">
                                <h4>Assure Hedge</h4>		      
                                <p>Created in WordPress</p>
                                <p>Company: Square1</p>

                                <div className="categories">Web Development</div>			               
                            </div>

                            <div className="link-box">
                                <a target="_blank" rel="noreferrer" href="https://www.assurehedge.com/">View site</a>
                                <a href="/#" rel="noreferrer" className="popup-modal-dismiss">Close</a>
                            </div>		      

                        </div>

                        <div id="modal-06" className="popup-modal slider mfp-hide">	

                                <div className="media">
                                    <img src={imgPort3} alt="Gale International" />
                                </div>      	

                            <div className="description-box">
                                <h4>Gale International</h4>		      
                                <p>Created in WordPress + Bootstrap</p>
                                <p>Company: Teravision Tech</p>

                                <div className="categories">Web Development</div>			               
                            </div>

                            <div className="link-box">
                                <a target="_blank" rel="noreferrer" href="http://www.galeintl.com/">View site</a>
                                <a href="/#" rel="noreferrer" className="popup-modal-dismiss">Close</a>
                            </div>		      

                        </div>

                        <div id="modal-07" className="popup-modal slider mfp-hide">	

                                <div className="media">
                                    <img src={imgPort4} alt="" />
                                </div>      	

                            <div className="description-box">
                                <h4>Antique Homes</h4>		      
                                <p>Created in WordPress + Bootstrap</p>
                                <p>Company: Teravision Tech</p>

                                <div className="categories">Web Development</div>			               
                            </div>

                            <div className="link-box">
                                <a target="_blank" rel="noreferrer" href="https://www.antiquehomesmagazine.com/">View site</a>
                                <a href="/#" rel="noreferrer" className="popup-modal-dismiss">Close</a>
                            </div>		      

                        </div>

                        <div id="modal-08" className="popup-modal slider mfp-hide">	

                                <div className="media">
                                    <img src={imgPort5} alt="Focalyx iOS" />
                                </div>      	

                            <div className="description-box">
                                <h4>Focalyx iOS</h4>		      
                                <p>XCode using Auto Layout Techniques in Interface builder</p>
                                <p>Company: Teravision Tech</p>

                                <div className="categories">App iOS</div>			               
                            </div>

                            <div className="link-box">
                                <a target="_blank" rel="noreferrer" href="https://apps.apple.com/es/app/focalyx/id1128496289">View site</a>
                                <a href="/#" rel="noreferrer" className="popup-modal-dismiss">Close</a>
                            </div>		      

                        </div>

                    </div>

                </div>

            </div>
            
        </section>
    )
}

export default Portfolio
